var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-link",attrs:{"type":"button"}},[_c('reviewer-avatar',{attrs:{"user":_vm.user,"img-size":24}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v(" "+_vm._s(_vm.user.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }